<app-nav-menu></app-nav-menu>
@if (loader) {
  <div style="width: 100%; height: 105vh; position: fixed; background: #e8e8e8de; z-index: 500;top:0 ">
    <div class="text-center" style="width: 100%; display: flex; justify-content: center; align-items: center; text-align: center; height: 100%; }">
      <div class="spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
}
<p-toast></p-toast>
<div class="main_class">
  <div class="main_page px-2 py-2">

    <!-- 1st bar -->
    <div class="pb-2 pt-2">
      <div class="alert alert-warning mb-0" role="alert">
        <i class="fa fa-info-circle fa-2x text-success" aria-hidden="true">
          <span class="notfication_text">
            Imported PNR From: <span class="gds_color">{{importPNR.bookingInfo.providerCode}}</span>
          </span>
        </i>
      </div>
    </div>
    <!-- 2nd bar -->
    <div class="pb-2">
      <div class="row m-0">

        <div class="col-md-9 pl-0 pr-1">
          <div class="header_one">
            <span class="name_class_of_header_one">
              NAME: {{importPNR.agencyOnline.agencyName}}
            </span>
            <br>
              <span class="email_class_of_header_one ">
                Email: {{importPNR.agencyOnline.emailAddress}} | Mobile:{{importPNR.agencyOnline.mobileContact}} | Phone:{{importPNR.agencyOnline.mobileContact}}
              </span>
            </div>

          </div>
          <div class="col-md-3  pr-0 pl-0">
            <div class="header_two">
              <span class="name_class_of_header_three">
                Reference Number
              </span>
              <br>
                <span class="name_class_of_header_four">
                  {{importPNR.bookingInfo.airReservationLocator}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- 3rd bar -->
        <div class="flightdetail_bar">
          <div class="row m-0">
            @for (city of importPNRSectorinfodisplay; track city; let i = $index) {
              <div class="col-md-8 p-2 fromortodetails_airportbar">
                <span class="pl-1 HEADING_BAR">{{city.fromCity}}</span><span class="pl-1 HEADING_BAR">To</span><span class="pl-1 HEADING_BAR">{{city.toCity}}</span>
              </div>
            }
            <div class="col-md-4 p-2 airlinedetails_bar">
              <div class="pnr_csr_mrg">
                <span>CSR PNR:</span><span> {{importPNR.bookingInfo.pnr}}</span><span> | </span><span>AIRLINE PNR: {{importPNR.bookingInfo.supplierLocatorCode}}</span><span> | </span><span>Status: {{ importPNR.bookingStatus }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 4th bar -->
        <div>
          <div class="table">
            <div class="table_header_color">
              <div class="row m-0">
                <div class="col-md-4">Airline</div>
                <div class="col-md-3">Departure</div>
                <div class="col-md-2">Arrival</div>
                <div class="col-md-2">Duration</div>
              </div>
            </div>
            <div class="table_body_airline">
              @for (flight of importPNRSectorinfodisplay; track flight; let i = $index) {
                <div class=" row m-0" style="border-bottom:1px solid var(--first-color-second)">
                  <div class="col-md-4">
                    <div class="imagelogo_airline">
                      <img src="assets/img/{{flight.airlineLogo}}" class="imageclasslogo" />
                      <span class="pt-2" style="font-weight: bold; padding: 5px">{{flight.airlinePrefixCode}}{{flight.flightNumber}}</span>
                      <!--<span class="pt-1" style="padding:5px">{{flight.airlineCode}}</span>-->
                      <span class="pt-2" style="padding:5px">RBD: {{flight.rbd}}</span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <span class="mt-7 " style="padding:5px">{{flight.fromAirport}}</span>
                    <br>
                      <span class="mt-4" style="font-weight: bold; padding: 5px">{{flight.departureTime.slice(0,5) }}</span>
                      <br>
                        <span class="mt-4" style="padding:5px">{{flight.departureDate | date:'fullDate'}}</span>
                        <br>
                          <br>
                            <br>
                              <!--<span>ILOWAE {{flight.toIATACODE}}</span>-->
                            </div>
                            <div class="col-md-2">
                              <span class="mt-7" style="padding:5px">{{flight.toAirport}}</span>
                              <br>
                                <span class="mt-4" style="font-weight: bold; padding: 5px">{{flight.arrivalTime.slice(0,5)}}</span>
                                <br>
                                  <span class="mt-4" style="padding:5px">{{flight.arrivalDate | date:'fullDate'}}</span>
                                </div>
                                <div class="col-md-2">
                                  <span class="mt-7" style="padding:5px">{{flight.flightStatus}}</span>
                                  <br>
                                    <span class="mt-4" style="padding: 5px; font-weight: bold; color: var(--first-color-second)">{{flight.noOfStops}} STOP</span>
                                  </div>
                                </div>
                              }


                            </div>
                          </div>
                        </div>
                        <!-- 5th bar -->
                        <div class="flightdetail_bar">
                          <div class="row m-0">
                            <div class="col-md-12 p-2 fromortodetails_airportbar">
                              <span class="pl-1 HEADING_BAR"> Passenger Details</span>
                            </div>
                          </div>
                        </div>

                        <!-- 6th bar -->
                        <div>
                          <div class="table">
                            <div class="table_header_color">
                              <div class="row m-0">
                                <div hidden>paxid</div>
                                <div class="col-md-3">Pax Name</div>
                                <div class="col-md-2">Pax Type</div>
                                <div class="col-md-2">Ticket No</div>
                                <!--<div class="col-md-3">Passport Number</div>-->
                                <!--<th class="col-md-3"></th>-->
                              </div>
                            </div>
                            @for (passenger of importPNRPassengerinfo; track passenger; let i = $index) {
                              <div class="table_body_airline">
                                <div class="row m-0">
                                  <div hidden>
                                    {{passenger.passengerID}}
                                  </div>
                                  <div class="col-md-3">
                                    {{passenger.firstNameShow}} {{passenger.lastName}}
                                  </div>
                                  <div class="col-md-2">
                                    {{passenger.typeName}}
                                  </div>
                                  <div class="col-md-2">
                                    {{passenger.ticketNo}}
                                    <!--<label for="validationServer02">Ticket No</label>
                                    <input type="date" class="form-control_input " name="tktno{{i}}" [(ngModel)]="passenger.ticketNo" required>-->
                                  </div>
                                  <!--<div class="col-md-3">
                                  <span class="dataofbirthps_table" (click)="DateofBirthPopUp(popupdob,i)">Add Date Of Birth</span>
                                  <span style="color:red;font-size:12px;font-weight:bold; margin-left:10px;" id="dateofbirthrequiredmessage{{i}}"></span>
                                </div>-->
                                <div class="col-md-2">
                                  <span class="dataofbirthps_table" (click)="PassengerDetailsPopUp(popup,i)">
                                    Add Passenger
                                    Details
                                  </span>
                                  <span style="color:red;font-size:10px;font-weight:bold; margin-left:10px;" id="passportrequiredmessage{{i}}"></span>
                                </div>
                                <!--<td>
                                <span>N.A</span> <span class="onward_return">(</span><span class="onward_return">onward</span><span class="onward_return">)</span>
                                <br>
                                  <span>N.A</span> <span class="onward_return">(</span><span class="onward_return">Return</span><span class="onward_return">)</span>
                                </td>-->
                              </div>
                              <div>
                              </div>
                              <!-- pop up section -->
                              <div>
                                <ng-template #popup let-modal>
                                  <div class="modal-header">
                                    <span class="closepopup" (click)="modal.dismiss()">&times;</span>
                                    <h2 class="textpopup"> Passenger Details</h2>
                                  </div>
                                  <div class="modal-body">
                                    <div style="margin-top:10px">
                                      <form class="form-line-active popuplabel">
                                        <div class="form-row ">
                                          <!--<div class="col-md-4 mb-3 ">
                                          <label for="validationServer01">ICOA Code</label>
                                          <input type="text" class="form-control " name="icaoCode" [(ngModel)]="newobj.icaoCode" id="validationServer01" placeholder="Please Enter ICOA CODE" required>
                                        </div>-->
                                        <div class="col-md-6 mb-3">
                                          <label for="validationServer02">Date Of Birth</label>
                                          <input type="date" class="form-control_input " name="paxdob{{i}}" [ngModel]="passenger.paxdob | date:'yyyy-MM-dd'" (blur)="passenger.paxdob=ParseDate($event.target.value)" required>
                                        </div>
                                        <div class="col-md-6 mb-3">
                                          <label for="validationServer02">Passport No</label>
                                          <input type="text" class="form-control_input " name="passportNumber{{i}}"
                                            placeholder="Please Enter Passport No" [(ngModel)]="passenger.passportNumber" required>
                                          </div>
                                          <div class="col-md-6 mb-3">
                                            <label for="validationServer01">Nationality</label>
                                            <ng-select class="branchinfongselect"
                                              [items]="countryList"
                                              bindLabel="countryName" bindValue="code"
                                              name="pAXNationality{{i}}" [(ngModel)]="passenger.paxNationality">
                                            </ng-select>
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-md-6 mb-3">
                                            <label for="validationServer03">Passport Issue Date</label>
                                            <div class="row">
                                              <div class="col-md-12">
                                                <input type="date" class="form-control_input " name="passportValidFrom{{i}}" [ngModel]="passenger.passportValidFrom | date:'yyyy-MM-dd'" (blur)="passenger.passportValidFrom=ParseDate($event.target.value)" required>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-md-6 mb-3">
                                            <label for="validationServer04">Passport Expiry Date</label>
                                            <div class="row">
                                              <div class="col-md-12">
                                                <input type="date" class="form-control_input " name="passportValidTo{{i}}" [ngModel]="passenger.passportValidTo | date:'yyyy-MM-dd'" (blur)="passenger.passportValidTo=ParseDate($event.target.value)" required>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="row m-0">
                                          <div class="col-md-6">
                                            <span style="color:red;font-weight:bold;font-size:12px;" id="Passportmessage{{i}}"></span>
                                          </div>
                                          <div class="col-md-6">
                                          </div>
                                        </div>
                                        <button class="btn submitButton" (click)="passengerDetailsPassport(passenger,i)">Submit</button>
                                      </form>
                                    </div>
                                    <!--<button type="submit" (click)="SelectedRows()" class="profilesearchbutton">Submit</button>-->
                                  </div>
                                  <!--<div id="employeeInfo" *ngIf="grid.selectedRowKeys.length">
                                  <input [value]="grid.instance.getSelectedRowsData()[0].lastName" />
                                </div>-->
                              </ng-template>
                            </div>
                          </div>
                        }
                      </div>
                    </div>

                    <!-- 7th bar -->
                    <div class="flightdetail_bar">
                      <div class="row m-0">
                        <div class="col-md-12 p-2 fromortodetails_airportbar">
                          <span class="pl-1 HEADING_BAR">Fare Summary</span>
                        </div>
                      </div>
                    </div>
                    <div class="">
                      <div class="row m-0">
                        <div class="col-md-12 p-2 ">
                          <span class="pl-1 HEADING_BAR">Fare After</span><span class="pl-1 HEADING_BAR">ATO Deals  </span>
                        </div>
                      </div>
                    </div>

                    <!-- 8th bar -->
                    <div>
                      <div class="table">
                        <div class="table_header_color">
                          <div class="row m-0">
                            <div class="col-md-2">Pax</div>
                            <div class="col-md-2">Basic Fare</div>
                            <div class="col-md-2">Tax & Charges</div>
                            <div class="col-md-2">Service Fee</div>
                            <div class="col-md-2">Discount </div>
                            <div class="col-md-2 total_class">Total</div>
                          </div>
                        </div>
                        <div class="table_body_airline p-1">
                          @if (adultfareId) {
                            <div class="row m-0">
                              <div class="col-md-2">
                                {{importPNRfaredetails.adultfare.paxtype}} x {{importPNRfaredetails.adultfare.paxcount}}
                              </div>
                              <div class="col-md-2">
                                {{importPNRfaredetails.adultfare.basecurrency}} {{importPNRfaredetails.adultfare.basefare}}
                              </div>
                              <div class="col-md-2">
                                <span> {{importPNRfaredetails.adultfare.basecurrency}} {{importPNRfaredetails.adultfare.totaltaxes}}</span>
                              </div>
                              <div class="col-md-2">
                                <span> {{importPNRfaredetails.adultfare.basecurrency}} {{importPNRfaredetails.adultfare.serviceCharges}}</span>
                              </div>
                              <div class="col-md-2">
                                <span> {{importPNRfaredetails.adultfare.basecurrency}} {{importPNRfaredetails.adultfare.discount}}</span>
                              </div>
                              <div class="col-md-2 total_class">
                                <span> {{importPNRfaredetails.adultfare.basecurrency}} {{importPNRfaredetails.adultfare.netTotal}}</span>
                              </div>
                            </div>
                          }
                          @if (childfareId) {
                            <div class="row m-0" id="childid">
                              <div class="col-md-2">
                                {{importPNRfaredetails.childfare.paxtype}} x {{importPNRfaredetails.childfare.paxcount}}
                              </div>
                              <div class="col-md-2">
                                {{importPNRfaredetails.childfare.basecurrency}}  {{importPNRfaredetails.childfare.basefare}}
                              </div>
                              <div class="col-md-2">
                                <span>{{importPNRfaredetails.childfare.basecurrency}}  {{importPNRfaredetails.childfare.totaltaxes}}</span>
                              </div>
                              <div class="col-md-2">
                                <span>{{importPNRfaredetails.childfare.basecurrency}}  {{importPNRfaredetails.childfare.serviceCharges}}</span>
                              </div>
                              <div class="col-md-2">
                                <span>{{importPNRfaredetails.childfare.basecurrency}}  {{importPNRfaredetails.childfare.discount}}</span>
                              </div>
                              <div class="col-md-2 total_class">
                                <span>{{importPNRfaredetails.childfare.basecurrency}} {{importPNRfaredetails.childfare.netTotal}}</span>
                              </div>
                            </div>
                          }
                          @if (infantfareId) {
                            <div class="row m-0" id="infantid">
                              <div class="col-md-2">
                                {{importPNRfaredetails.infantfare.paxtype}} x {{importPNRfaredetails.infantfare.paxcount}}
                              </div>
                              <div class="col-md-2">
                                {{importPNRfaredetails.infantfare.basecurrency}} {{importPNRfaredetails.infantfare.basefare}}
                              </div>
                              <div class="col-md-2">
                                <span>{{importPNRfaredetails.infantfare.basecurrency}} {{importPNRfaredetails.infantfare.totaltaxes}}</span>
                              </div>
                              <div class="col-md-2">
                                <span>{{importPNRfaredetails.infantfare.basecurrency}} {{importPNRfaredetails.infantfare.serviceCharges}}</span>
                              </div>
                              <div class="col-md-2">
                                <span>{{importPNRfaredetails.infantfare.basecurrency}} {{importPNRfaredetails.infantfare.discount}}</span>
                              </div>
                              <div class="col-md-2 total_class">
                                <span>{{importPNRfaredetails.infantfare.basecurrency}} {{importPNRfaredetails.infantfare.netTotal}}</span>
                              </div>
                            </div>
                          }
                          <div class="row m-0">
                            <div class="col-md-6">
                              <span class="your_fare">Your Fare</span>
                            </div>

                            <div class="col-md-6 ">
                              <div class="row justify-content-end">
                                <span class="grand_total">
                                  Grand Total:
                                </span>
                                @if (adultfareId) {
                                  <span class="grand_total">
                                    {{importPNRfaredetails.adultfare.basecurrency}} {{totalAmount}}
                                  </span>
                                }
                              </div>

                            </div>
                          </div>
                          @if (serviceChargesPerPassenger > 0 && showServiceChargesModalForBranch && importPNR.bookingStatus === 'Booked') {
                            <div class="row m-0">
                              <div class="col-md-6">
                                <span class="your_fare">Your Fare</span>
                              </div>
                              <div class="col-md-6 ">
                                <div class="row justify-content-end">
                                  <span class="grand_total">
                                    Grand Total After Service Charges:
                                  </span>
                                  @if (adultfareId) {
                                    <span class="grand_total">
                                      {{importPNRfaredetails.adultfare.basecurrency}} {{totalSumAmount}}
                                    </span>
                                  }
                                </div>
                              </div>
                            </div>
                          }


                        </div>
                      </div>
                    </div>
                    @if (importPNR.bookingStatus === 'Booked') {
                      <div class="row mb-3">
                        <div class="col-md-4">
                          <label class="font-weight-bold mb-1">Issue PCC</label>
                          <ng-select [items]="(pccList$ | async)"
                            bindLabel="officeId"
                            bindValue="officeId"
                            [(ngModel)]="selectedPcc"
                            placeholder="Select PCC"
                            [clearable]="false">
                          </ng-select>
                        </div>
                        <div class="col-md-4">
                          @if (showServiceChargesModalForBranch && importPNR.bookingStatus === 'Booked') {
                            <button class="button-87" (click)="openServiceChargesModel(addServiceCharges)"> Add Service Charges</button>
                          }
                        </div>
                      </div>
                    }
                    <!-- 5th bar -->
                    <div class="rulesRestriction_bar">
                      <div class="row m-0" hidden>
                        <div class="col-md-12 p-2 fromortodetails_airportbar">
                          <span class="pl-1 HEADING_BAR"> Rules & Restrictions</span>
                        </div>
                      </div>
                    </div>
                    <div class="rulesRestrictionData_bar">
                      <div class="row m-0">
                        <div class="col-md-12 p-2 fromortodetails_airportbar">
                          <p class="pl-1" hidden>The above mentioned purchases are subject to cancellation, date change fees and once purchased tickets are non-transferable and name changes are not permitted. For further details, read the overview of all the</p>
                          <p hidden>Restriction, Penalties & Cancellation Charges, </p>
                          <div class="row m-0 checkbox_mrg" id="buttonissue1">
                            <input type="checkbox" class="red-input " [(ngModel)]="agreed" (change)="active()"><p class="pl-1"> I accept <span class="terms_cond" (click)="importtermsncond(termsncond)">Terms & Conditions</span></p>
                          </div>
                          <div class="row m-0 " hidden>
                            <input type="radio" class="option-inputs radio"> <p class="pl-1">Use Deposit Account</p>
                          </div>
                          <div class="row m-0">

                            <div class="col-md-4">
                              <div class="loaders" id="loaderissue">
                                <img src="../../assets/img/IMPORTPNRLOADER.svg" style="height: 50px;" />
                              </div>
                              <div class="row m-0">
                                <div id="buttonissue">
                                  @if (importPNR.bookingStatus === 'Booked') {
                                    <button
                                      class="Contniue_btn sendButton"
                                      [disabled]="buttonagreed"
                                      (click)="IssueTicket(farestabimport)">
                                      Issue Ticket
                                    </button>
                                  }
                                </div>
                                <div>
                                  <button (click)="cancel()" class="Cancel_btn ml-2">Cancel</button>
                                </div>

                                <div>
                                  @if (showPostInvoiceAfterIssuanceForAccounts) {
                                    <button
                                      type="button"
                                      class="post-invoice-btn"
                                      (click)="PostInvoiceForTicketsIssuedOfflineImportedThroughImportPnr()"
                                      [disabled]="isPostingInvoice">
                                      Post Invoice
                                    </button>
                                  }
                                </div>
                              </div>
                            </div>



                            <div>

                            </div>

                          </div>
                          <div class="row m-0">
                            <span style="color:red;font-size:12px;" id="issueerror"></span>
                          </div>
                          <div class="row m-0">
                            <span style="color:green;font-size:12px;" id="invoice-msg"></span>
                          </div>
                        </div>
                      </div>
                    </div>




                  </div>
                </div>

                <ng-template #customerLimitExceededModal let-modal>
                  <div class="modal-header bg-warning text-dark">
                    <h5 class="modal-title">
                      Customer Limit Exceeded
                    </h5>

                    <button type="button"
                      class="close"
                      aria-label="Close"
                      (click)="modal.dismiss('cancel')">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div class="modal-body">
                    <p>
                      The customer's credit limit has been exceeded.
                    </p>

                    <p class="mb-0">
                      Do you still want to post the invoice?
                    </p>
                  </div>

                  <div class="modal-footer">
                    <button class="btn btn-secondary"
                      (click)="modal.close(false)">
                      No
                    </button>

                    <button class="btn btn-primary"
                      (click)="modal.close(true)">
                      Yes
                    </button>
                  </div>
                </ng-template>
                <ng-template #farestabimport let-modal>
                  <div style="padding:10px;">
                    <div class="row m-0 headerimport">
                      <div class="col-md-10 justify-content-center"><span class="header_section_name">Fare Change</span></div>
                      <div class="col-md-2">
                        <span class="closepopups" (click)="modal.dismiss()">&times;</span>
                      </div>
                    </div>
                    <div class=" mt-2 p-2">
                      <div>
                        <p style="text-align:justify">
                          We regert on a change in the Fare for the Flight you have selected.You may proceed with the new fare or return
                          to the results page and select a different Flight.
                        </p>
                      </div>
                      <div class="row m-0">
                        <div class="col-md-4">
                          <span class="sub_import_header">Previous Fare</span>
                        </div>
                        <div class="col-md-4">
                          <span class="sub_import_header">New Fare</span>
                        </div>
                        <div class="col-md-4">

                        </div>
                      </div>
                      <div class="row m-0">
                        <div class="col-md-4">
                          <span class="sub_header_price">{{importpnrreturndata.oldPrice}}</span>
                        </div>
                        <div class="col-md-4">
                          <span class="sub_header_price">{{importpnrreturndata.newPrice}}</span>
                        </div>

                      </div>
                      <div class="row m-0 justify-content-end mr-3">
                        <span class="sub_import_header">Total Fare:</span><span class="total_price_fares">{{importpnrreturndata.newPrice}}</span>
                      </div>
                      <div class="row m-0 mt-2">
                        <div class="col-md-3">
                          <button class="button-iMAGE" (click)="RejectPriceChange()">Reject</button>
                        </div>
                        <div class="col-md-3">
                          <button class="button-iMAGE" (click)="AcceptPriceChange()">Accept</button>
                        </div>
                        <div class="col-md-3">
                          <button class="cancel_buttons" (click)="RejectPriceChange()">Cancel</button>
                        </div>
                        <div class="col-md-3">
                          <div class="loaders" id="loaderimportpnrpopup">
                            <img src="../../assets/img/IMPORTPNRLOADER.svg" style="height: 50px;" />
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div id="overlay"></div>
                  <div class="error-dialogfor-ist ist-hide">
                    <!--<div class="ist-container">
                    <p class="message-ist"></p>
                    <button class="error-btn-ist" (click)="errorClose()">OK</button>
                  </div>-->



                </div>
              </ng-template>
              <div class="easeoutin">
                <ng-template #addServiceCharges let-modal>
                  <div class="modal-success " style="width:max-content">
                    <p class="textpopupsuccess"> Add Service Charges</p>
                    <form class="noti col-sm-12 form-line-active">

                      <div>
                        <div class="forms_container_main infant_type">
                          <div class="main_form">
                            <div class="row m-0 py-2">

                              <div class="col-sm-4 poisiton_Columns  px-1">

                                <input class="main_text-box new_main_Text_Box " [(ngModel)]="totalAmount" id="totalPurchaseAmount" name="totalPurchaseAmount" type="text" readonly />
                                <div>
                                  <label for="" class="input_lab_first">Amount</label>
                                </div>


                              </div>
                              <div class="col-sm-4 poisiton_Columns  px-1">

                                <input class="main_text-box" type="number" [(ngModel)]="serviceChargesPerPassenger" name="serviceChargesPerPassenger" min="0">
                                <div>
                                  <label for="" class="input_lab_first">Add Service Charges Per Passenger</label>
                                </div>
                              </div>
                              <div class="col-sm-4 poisiton_Columns px-1">
                                <input class="main_text-box"
                                  type="text"
                                  [(ngModel)]="totalSumAmount"
                                  name="totalSumAmount"
                                  readonly>
                                  <div>
                                    <label class="input_lab_first">Total Amount</label>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div class="marginbtnlfttt">
                          <div>
                            <button class="yesButton" (click)="applyServiceCharges(modal)">Apply Service charges</button>
                          </div>
                          <!--<div>
                          <button class="yesButton" (click)="PostInvoiceForBranches()" [disabled]="isPostingInvoice">Post Invoice</button>
                        </div>-->
                        <div>
                          <button class="noButton" (click)="modal.dismiss()">No</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </ng-template>
              </div>
              <div class="easeoutin">
                <ng-template #issueticketNoRight let-modal>
                  <div class="modal-success">
                    <img class="sucesspopup" src="assets/img/icons8-error.gif" />

                    <p class="textpopupsuccess">{{ modalTitle }}</p>

                    <p class="innerhtmlofmodal">
                      {{ modalMessage }}
                    </p>
                  </div>
                </ng-template>
              </div>
              <ng-template #termsncond let-modal>
                <div style="padding:10px;">
                  <div class="row m-0 headerimport">
                    <div class="col-md-10 justify-content-center"><span class="header_section_name">Terms & Conditions</span></div>
                    <div class="col-md-2">
                      <span class="closepopups" (click)="modal.dismiss()">&times;</span>
                    </div>
                  </div>
                  <div class=" mt-2 p-2">
                    <div>
                      <p style="text-align:justify">
                        Terms and Condition comming soon...................................................
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
